import SmartHRSyncReportPage from './SmartHRSyncReportPage';

export default SmartHRSyncReportPage;
